/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm, replacePXinStringWithEM, disable } from '@insticator/insticator-ui';



/* ++++++++++ --------------- LABEL ASSIGNMENT FIELD : STYLES --------------- ++++++++++ */
export default {
    dropdownmenuitem: {
        display: 'flex',
        alignItems: 'center',
        padding: replacePXinStringWithEM('7px 0'),
        fontSize: pxToEm(14),
        fontWeight: '500',
        color: theme.color.supporting.medium.swatch,
        background: theme.color.light.light.swatch,
        cursor: 'pointer',
        transition: 'all .15s',
        '& .itemtext': {
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        '&:hover':{
            color: theme.color.primary.medium.swatch
        },
        '& .highlight':{
            fontWeight: '600',
            background: theme.color.primary.light.swatch
        }
    }
};
